<h1 mat-dialog-title>Find Flight</h1>
<form [formGroup]="form">
  <div mat-dialog-content>
    <div layout="column">
      <mat-form-field flex>
        <input matInput placeholder="Flight ID" formControlName="dispatchId" />
      </mat-form-field>
      <td-message
        *ngIf="flightNotFound"
        sublabel="The flight could not be found."
        class="bgc-light-blue-200"
        icon="info"
      ></td-message>
      <ng-container *ngIf="hasFlightLogData">
        <td-message
          sublabel="Flight Search Results"
          class="bgc-light-blue-200"
          icon="info"
        ></td-message>

        <table mat-table [dataSource]="searchResults?.data">
          <ng-container *ngFor="let column of dataColumns" [matColumnDef]="column.name">
            <th mat-header-cell *matHeaderCellDef>
              {{ column.label }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row[column.name] }}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let row">
              <button
                *ngIf="row.logExists === true"
                (click)="onViewLog(row.logID)"
                matTooltip="View log for this flight"
                mat-button
              >
                <mat-icon>assignment</mat-icon>
                View
              </button>
              <button
                *ngIf="row.logExists === true"
                (click)="onAddAnotherLog()"
                matTooltip="Create another log for this flight"
                mat-button
              >
                <mat-icon>add</mat-icon>
                Create Another Log
              </button>
              <button
                *ngIf="row.logExists === false"
                (click)="onAddNewLog()"
                matTooltip="Create a log for this flight"
                mat-button
              >
                <mat-icon>add</mat-icon>
                Create New Log
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>
        </table>
      </ng-container>
    </div>
  </div>
  <div mat-dialog-actions>
    <button
      mat-button
      (click)="onSearch()"
      [disabled]="form.invalid || submitting"
      *ngIf="!hasFlightLogData && !flightNotFound"
    >
      Find
    </button>
    <button
      mat-button
      (click)="onAddNewLogNoCADInfo()"
      *ngIf="flightNotFound"
      [disabled]="submitting"
    >
      Add New Log
    </button>
    <button mat-button (click)="onCancel()">Cancel</button>
  </div>
</form>
